import { render, staticRenderFns } from "./StrokeTotals.vue?vue&type=template&id=2484fdf2&"
import script from "./StrokeTotals.vue?vue&type=script&lang=ts&"
export * from "./StrokeTotals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2484fdf2')) {
      api.createRecord('2484fdf2', component.options)
    } else {
      api.reload('2484fdf2', component.options)
    }
    module.hot.accept("./StrokeTotals.vue?vue&type=template&id=2484fdf2&", function () {
      api.rerender('2484fdf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-viz/StrokeTotals.vue"
export default component.exports